import type { ProblemResponse } from './types'

export function isBetLoopProblemResponse(
  response: ProblemResponse | Error
): response is ProblemResponse {
  return 'status' in response && 'title' in response && 'detail' in response
}
